export const ADMIN = {
  sv: {
    title: "Adminpanel",
    subtitle: "Hämta Allt · Norrköping",
    email: "E-post",
    password: "Lösenord",
    login: "Logga in",
    loggingIn: "Loggar in...",
    logout: "Logga ut",
    backToSite: "Till butiken",
    invalid: "Fel e-post eller lösenord",
    notAdmin: "Detta konto har inte adminbehörighet",
    loginHint: "Logga in med ditt befintliga adminkonto.",
    tabOrders: "Beställningar",
    tabStores: "Butiker",
    tabProducts: "Produkter",
    tabChat: "Chatt",
    tabStats: "Översikt",
    tabImport: "Import",
    importTitle: "Importera Orient-sortiment",
    importDesc: "Skapar alla avdelningar och produkter i backend så du kan redigera och lägga till bilder.",
    startImport: "Starta import",
    importing: "Importerar...",
    importDone: "Import klar",
    created: "skapade",
    skipped: "hoppade över",
    failed: "misslyckade",
    ensureStore: "Skapar avdelning",
    importNote: "Bilder läggs till per produkt under fliken Produkter efter importen.",
    tabDelivery: "Leverans",
    delTitle: "Leveransavgift",
    delDesc: "Fast avgift för alla beställningar. Gratis leverans t.o.m. valt datum.",
    delFee: "Leveransavgift (kr)",
    delFreeOver: "Fri leverans över (kr)",
    freeUntil: "Gratis leverans t.o.m.",
    delSave: "Spara",
    delSaved: "Sparat",
    refresh: "Uppdatera",
    newOrder: "Ny beställning",
    newOrdersN: "nya beställningar",
    enableAlerts: "Aktivera aviseringar",
    alertsOn: "Aviseringar på",
    sound: "Ljud",
    all: "Alla",
    noOrders: "Inga beställningar",
    order: "Order",
    status: "Status",
    amount: "Belopp",
    payment: "Betalning",
    items: "Varor",
    customer: "Kund",
    approve: "Godkänn",
    reject: "Avvisa",
    refund: "Återbetala",
    delete: "Ta bort",
    save: "Spara",
    setStatus: "Sätt status",
    setAmount: "Ändra belopp",
    confirmDelete: "Är du säker?",
    done: "Klart",
    error: "Något gick fel",
    createStore: "Ny butik",
    storeName: "Butiksnamn",
    category: "Kategori",
    color: "Färg",
    add: "Lägg till",
    yourStores: "Egna butiker",
    noStores: "Inga egna butiker ännu",
    hide: "Dölj / ta bort",
    createProduct: "Ny produkt",
    store: "Butik",
    productName: "Produktnamn",
    filterAll: "Alla sektioner",
    searchPlaceholder: "Sök produkt…",
    showingFirst: "Visar",
    refineHint: "filtrera eller sök för att se fler",
    hideAction: "Dölj",
    showAction: "Visa",
    hiddenBadge: "Dold",
    selectSection: "Välj avdelning",
    stock: "Lager (antal)",
    stockLeft: "kvar",
    unlimited: "Obegränsat",
    outOfStock: "Slut",
    statusLabel: "Status",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    statusDraft: "Utkast",
    price: "Pris",
    oldPrice: "Ordinarie pris (rea)",
    emoji: "Emoji",
    image: "Bild",
    uploading: "Laddar upp...",
    allProducts: "Alla produkter",
    noProducts: "Inga produkter",
    threads: "Konversationer",
    noThreads: "Inga konversationer",
    typeReply: "Skriv ett svar...",
    send: "Skicka",
    selectThread: "Välj en konversation",
    kr: "kr",
  },
  ar: {
    title: "لوحة الأدمن",
    subtitle: "Hämta Allt · نورشوبينغ",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    login: "تسجيل الدخول",
    loggingIn: "جارٍ الدخول...",
    logout: "تسجيل الخروج",
    backToSite: "إلى المتجر",
    invalid: "بريد أو كلمة مرور خاطئة",
    notAdmin: "هذا الحساب لا يملك صلاحية أدمن",
    loginHint: "سجّل الدخول بحساب الأدمن الموجود لديك.",
    tabOrders: "الطلبات",
    tabStores: "المتاجر",
    tabProducts: "المنتجات",
    tabChat: "الدردشة",
    tabStats: "نظرة عامة",
    tabImport: "استيراد",
    importTitle: "استيراد منتجات Orient",
    importDesc: "يُنشئ كل الأقسام والمنتجات في الـBackend لتتمكن من التعديل وإضافة الصور.",
    startImport: "ابدأ الاستيراد",
    importing: "جارٍ الاستيراد...",
    importDone: "اكتمل الاستيراد",
    created: "مُضافة",
    skipped: "متجاوَزة",
    failed: "فاشلة",
    ensureStore: "إنشاء القسم",
    importNote: "تُضاف الصور لكل منتج من تبويب المنتجات بعد الاستيراد.",
    tabDelivery: "التوصيل",
    delTitle: "رسوم التوصيل",
    delDesc: "سعر ثابت لكل الطلبات. توصيل مجاني حتى التاريخ المحدد.",
    delFee: "رسوم التوصيل (كرونة)",
    delFreeOver: "توصيل مجاني فوق (كرونة)",
    freeUntil: "توصيل مجاني حتى",
    delSave: "حفظ",
    delSaved: "تم الحفظ",
    refresh: "تحديث",
    newOrder: "طلب جديد",
    newOrdersN: "طلبات جديدة",
    enableAlerts: "تفعيل الإشعارات",
    alertsOn: "الإشعارات مفعّلة",
    sound: "الصوت",
    all: "الكل",
    noOrders: "لا توجد طلبات",
    order: "طلب",
    status: "الحالة",
    amount: "المبلغ",
    payment: "الدفع",
    items: "المنتجات",
    customer: "الزبون",
    approve: "قبول",
    reject: "رفض",
    refund: "استرجاع",
    delete: "حذف",
    save: "حفظ",
    setStatus: "تغيير الحالة",
    setAmount: "تعديل المبلغ",
    confirmDelete: "هل أنت متأكد؟",
    done: "تم",
    error: "حدث خطأ",
    createStore: "متجر جديد",
    storeName: "اسم المتجر",
    category: "القسم",
    color: "اللون",
    add: "إضافة",
    yourStores: "المتاجر المخصّصة",
    noStores: "لا توجد متاجر مخصّصة بعد",
    hide: "إخفاء / حذف",
    createProduct: "منتج جديد",
    store: "المتجر",
    productName: "اسم المنتج",
    filterAll: "كل الأقسام",
    searchPlaceholder: "ابحث عن منتج…",
    showingFirst: "عرض أول",
    refineHint: "فلتر أو ابحث لعرض الباقي",
    hideAction: "إخفاء",
    showAction: "إظهار",
    hiddenBadge: "مخفي",
    selectSection: "اختر القسم",
    stock: "المخزون (الكمية)",
    stockLeft: "متبقٍ",
    unlimited: "غير محدود",
    outOfStock: "نفد",
    statusLabel: "الحالة",
    statusActive: "فعّال",
    statusInactive: "غير فعّال",
    statusDraft: "مسودة",
    price: "السعر",
    oldPrice: "السعر الأصلي (تخفيض)",
    emoji: "إيموجي",
    image: "صورة",
    uploading: "جارٍ الرفع...",
    allProducts: "كل المنتجات",
    noProducts: "لا توجد منتجات",
    threads: "المحادثات",
    noThreads: "لا توجد محادثات",
    typeReply: "اكتب رداً...",
    send: "إرسال",
    selectThread: "اختر محادثة",
    kr: "كرونة",
  },
};
